const AGENT_TEMPLATES_ADMIN_LIST_TAG = '/admin/agent-templates';
export const AGENT_TEMPLATES_ADMIN_RECORD_TAG = '/admin/agent-templates/{id}';
export const AGENT_TEMPLATES_ADMIN_VERSIONS_TAG = '/admin/agent-templates/{id}/versions';

export default AGENT_TEMPLATES_ADMIN_LIST_TAG;
